export default __webpack_public_path__ + "static/media/Holmes.4abc67b6.png";